var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9109 15.9839L13.8203 14.8445V11.0195H14.1803V14.5943L17.0351 15.6473L16.9109 15.9839Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0006 7.68164C12.3068 7.68164 10.6814 8.37464 9.50242 9.56984L9.39622 8.24504L8.31982 8.33144L8.57722 11.557L8.76802 11.5228L10.784 11.1556L11.7812 10.9738L11.5868 9.91184L10.4996 10.1098C11.4536 9.25304 12.7028 8.76164 14.0006 8.76164C16.8878 8.76164 19.2386 11.1124 19.2386 13.9996C19.2386 16.8868 16.8878 19.2376 14.0006 19.2376C11.1134 19.2376 8.76262 16.8868 8.76262 13.9996C8.76262 13.5856 8.81122 13.1734 8.90842 12.7738L8.28382 13.2472L7.85362 12.5416C7.74022 13.0168 7.68262 13.5064 7.68262 13.9996C7.68262 17.4826 10.5176 20.3176 14.0006 20.3176C17.4836 20.3176 20.3186 17.4826 20.3186 13.9996C20.3186 10.5166 17.4836 7.68164 14.0006 7.68164Z",
    fill: "#004C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/IconHistory.ce5205a81b7de7a798c264acbc9ef6b4.svg";
export { ForwardRef as ReactComponent };